/* 🤖 this file was generated by svg-to-ts */
export const matIconControlPointDuplicate: {
  name: 'control-point-duplicate';
  data: string;
} = {
  name: 'control-point-duplicate',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3V8zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16A6.99 6.99 0 0 1 2 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"/></svg>`
};
